export default "__VITE_ASSET__4b68bad5__"